import { Injectable, SecurityContext } from '@angular/core';
import { ParamContext } from '../../service/param.context';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { GERMPLASM_LIST_MANAGER_URL, ViewEnum } from '../../../app.constants';


@Injectable()
export class GermplasmListUrlService {

    queryParams: string;

    constructor(
        private paramContext: ParamContext,
        private sanitizer: DomSanitizer
    ) {
    }

    getUrl(listId: any, listName: string): SafeResourceUrl {
        return this.sanitizer.sanitize(SecurityContext.URL, this.getUrlAsString(listId, listName));
    }

    getUrlAsString(listId: any, listName: string): string {
        this.queryParams = '?cropName=' + this.paramContext.cropName
            + '&programUUID=' + this.paramContext.programUUID
            + '&selectedProjectId=' + this.paramContext.selectedProjectId
            + '&loggedInUserId=' + this.paramContext.loggedInUserId;
        return GERMPLASM_LIST_MANAGER_URL + listId + this.queryParams + '&toolUrl=' + ViewEnum.GERMPLASM_LIST_MANAGER + '&listId=' + listId + '&listName=' + listName;
    }
}
